import { BellOutlined } from "@ant-design/icons";
import { Badge, Button } from "antd";

export const SinoNotificacao = ({ quantidade = 0, onClick }) => {
  return (
    <Button
      type="text"
      onClick={onClick}
      title="Mensagens não lidas"
      aria-label="Mensagens não lidas"
      style={{
        height: "100%",
        border: "none",
        background: "none",
        padding: "0 8px",
        display: "inline-flex",
        alignItems: "center",
      }}
    >
      <Badge count={quantidade} overflowCount={99} size="small">
        <BellOutlined style={{ fontSize: "1.25rem" }} />
      </Badge>
    </Button>
  );
};
